import { Component } from "@angular/core";
import { FpFooterComponent } from "../common/fp-footer/fp-footer.component";
import { FpNavbarComponent } from "../common/fp-navbar/fp-navbar.component";
import { RouterOutlet } from "@angular/router";

@Component({
    selector: 'app-legal-pages',
    imports: [ FpFooterComponent, FpNavbarComponent, RouterOutlet  ],
    templateUrl: './legal-pages.component.html',
    styleUrl: './legal-pages.component.scss',
    standalone: true
})
export class LegalPagesComponent {

    constructor(

    ) {}

    ngOnInit(): void {

    }

}